"use strict";
export function ViewGestureHandler({ children }) {
  return <>{children}</>;
}
